import PropTypes from 'prop-types';
import { DropdownService } from '../services/dropdown-service';

export const DropdownMenuPositionPropType = PropTypes.oneOf(DropdownService.getValidPositions());
